<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'billing.pre-billing.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <header>
      <form [formGroup]="siteForm" (submit)="onSubmitSiteForm()" *ngIf="!isLoading && siteForm" class="siteForm">
        <div class="field">
          <app-autocomplete  [control]="getControl('site')"
            [list]="sites" label="billing.pre-billing.list.site">
          </app-autocomplete>
        </div>

        <button type="submit" mat-raised-button
          color="primary" [disabled]="siteForm.invalid">{{ "billing.pre-billing.list.submit" | translate }}</button>
      </form>
    </header>

    <main *ngIf="siteSelected">
        <mat-tab-group>
            <mat-tab class="active" [label]="'billing.pre-billing.history.title' | translate">
                <app-pre-billing-history [site]="getSelectedSite()"></app-pre-billing-history>
            </mat-tab>
            <mat-tab [label]="'billing.pre-billing.new.title' | translate">
                <app-pre-billing-new [site]="getSelectedSite()"></app-pre-billing-new>
            </mat-tab>
        </mat-tab-group>
    </main>
  </mat-card-content> 
</mat-card> 